var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"profile__main-content-section profile__delete-section"},[_c('button',{staticClass:"sk-btn sk-btn--white profile__delete-account",on:{"click":_vm.deleteAccount}},[_vm._v(_vm._s(_vm.$gettext('Delete my account')))])])}
var staticRenderFns = []

export { render, staticRenderFns }